module.exports = __webpack_public_path__ + "img/accd1b4.png";